/**
 * Roary is available to admins and to admin mimic sessions (Build with Roary).
 * Regular users do not see Roary entry points or branding in the product UI.
 */
export function canUseRoary(isAdmin: boolean, isMimicking: boolean): boolean {
  return isAdmin || isMimicking;
}
